import React, { Component } from 'react';
import { Button, Checkbox, Input, Divider, Select, Table, message, Spin } from 'antd';
import { PostForm, PostJson } from '../../utils/http';
import { debounce } from 'lodash';
import cn from './index.module.css';

export function DebounceSelect({ debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      if (!value) return;
      setOptions([]);
      setFetching(true);
      PostForm({
        url: '/api/refdata/fuzzySearchSymbol',
        data: { keyword: value },
        error: (data) => {
          const symbolsList = data.splice(0, 20).map(item => ({
            symbol: item.symbol,
            cnname: item.cnDisplayName,
            label: item.symbol + ' ' + item.cnDisplayName,
            value: item.symbol
          }));
          setOptions([...symbolsList]);
          setFetching(false);
        },
      });
    };
    return debounce(loadOptions, debounceTimeout, { leading: true });
  }, [debounceTimeout, setFetching]);
  return (
    <Select
      showSearch
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      onChange={val => {
        const rec = options.find(item => item.value === val.value)
        props.onChange(rec)
      }}
      style={{ width: 200 }}
      options={options}
    />
  );
} // Usage of DebounceSelect

const options = [
  { type: 'D', title: '日线' },
  { type: 'W', title: '周线' },
  { type: 'M', title: '月线' },
  { type: '6', title: '小时线' },
]
class Migration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      default_config: {
        'D': 400,
        'W': 400,
        'M': 400,
        '6': 400,
      },
      config: {
      },
      symbol: '',
      dataSource: [],
    };
  }
  handleCheck = (checked, key) => {
    const { config, default_config } = this.state;
    if (checked) {
      config[key] = config[key] || default_config[key];
    } else {
      delete config[key];
    }
    this.setState({ config });
  }
  handleValue = (value, key) => {
    const { config } = this.state;
    if (!value) {
      config[key] = '';
    } else {
      config[key] = Number.parseInt(value);
      if (Number.isNaN(config[key])) return;
    }
    this.setState({ config });
  }
  handleSymChange = (symbol) => {
    this.setState({ symbol });
  }
  handleDelSym = ({ symbol }) => {
    const { dataSource } = this.state;
    const n_dataSource = dataSource.filter(item => item.symbol !== symbol);
    this.setState({ dataSource: n_dataSource });
  }
  handleAddSymbol = () => {
    const { symbol, dataSource } = this.state;
    this.setState({ dataSource: [...dataSource, symbol] });
  }
  handleSubmit = () => {
    const { dataSource, config } = this.state;
    const n_config = Object.keys(config).map(item => {
      const count = config[item];
      return { type: item, count }
    });
    PostJson({
      url: '/api/kline/startMigration.json',
      data: { symbols: dataSource.map(item => item.value).join(';'), config: n_config },
      success: (data) => {
        message.success('操作成功');
      },
      error: (data) => {
        console.log("error", data)
        message.error(data['msg']);
      },
    });
  }
  render() {
    const { config, default_config, dataSource = [] } = this.state;
    console.log(dataSource)
    return (
      <div>
        <div className={cn.form}>
          {
            options.map(item => (
              <Input
                value={config[item.type] || default_config[item.type]}
                onChange={(e) => this.handleValue(e.target.value, item.type)}
                className={cn.input}
                key={item.type}
                addonBefore={<div><Checkbox onChange={(e) => this.handleCheck(e.target.checked, item.type)} /> {item.title}</div>}
                addonAfter="根"
                disabled={config[item.type] === undefined}
              />
            ))
          }
        </div>
        <Button className={cn.input} type="primary" onClick={this.handleSubmit}>提交</Button>
        <Divider dashed />
        <div className={cn.symbol}>
          <DebounceSelect
            placeholder="请选择股票"
            onChange={this.handleSymChange}
          />
          <Button className={cn.add} onClick={this.handleAddSymbol}>添加</Button>
        </div>
        <Table
          rowKey="value"
          className={cn.table.migration}
          dataSource={dataSource}
          pagination={false}
          size="small"
          locale={{ emptyText: '请添加数据' }}
          columns={[
            { title: '股票', dataIndex: 'symbol' },
            // { title: '股票', dataIndex: 'label' },
            { title: '股票中文名', dataIndex: 'cnname' },
            { title: '操作', render: (rec) => (<Button type="link" onClick={() => this.handleDelSym(rec)}>删除</Button>) }
          ]}
        />
      </div>
    )
  }
}

export { Migration };
